import {route} from "preact-router";
import {showYourYearModal} from "components/organisms/modal/modals";

const YourYear = () => {
    route('/');
    showYourYearModal();
    return null;
};

export default YourYear;